import React from "react";
import { Thermometer } from "lucide-react";
import { Label } from "./ui/label";
import { Input } from "./ui/input";

export const isTermohigrometro = (item) => {
  const txt = `${item?.nome_item || ""} ${item?.categoria || ""}`.toLowerCase();
  return ["termo", "thermo", "higrometro", "higrômetro", "termômetro"].some((k) => txt.includes(k));
};

export const FAIXA_CAMPOS = ["faixa_temp_min", "faixa_temp_max", "faixa_umid_min", "faixa_umid_max"];

export const avaliarFaixa = (item, leitura) => {
  const fora = [];
  const num = (v) => (v === "" || v === null || v === undefined ? null : parseFloat(v));
  const tMin = num(item?.faixa_temp_min), tMax = num(item?.faixa_temp_max);
  const uMin = num(item?.faixa_umid_min), uMax = num(item?.faixa_umid_max);
  const atual = num(leitura.temperatura_lida), lMin = num(leitura.temperatura_min), lMax = num(leitura.temperatura_max);
  const umid = num(leitura.umidade_lida);
  if (tMin !== null && atual !== null && atual < tMin) fora.push(`Temp. atual ${atual}°C abaixo de ${tMin}°C`);
  if (tMax !== null && atual !== null && atual > tMax) fora.push(`Temp. atual ${atual}°C acima de ${tMax}°C`);
  if (tMin !== null && lMin !== null && lMin < tMin) fora.push(`Temp. mínima registrada ${lMin}°C abaixo de ${tMin}°C`);
  if (tMax !== null && lMax !== null && lMax > tMax) fora.push(`Temp. máxima registrada ${lMax}°C acima de ${tMax}°C`);
  if (uMin !== null && umid !== null && umid < uMin) fora.push(`Umidade ${umid}% abaixo de ${uMin}%`);
  if (uMax !== null && umid !== null && umid > uMax) fora.push(`Umidade ${umid}% acima de ${uMax}%`);
  return fora;
};

export const temFaixa = (item) => FAIXA_CAMPOS.some((c) => item?.[c] !== null && item?.[c] !== undefined && item?.[c] !== "");

export const descreverFaixa = (item) => {
  const partes = [];
  if (item?.faixa_temp_min != null || item?.faixa_temp_max != null) {
    partes.push(`Temp. ${item.faixa_temp_min ?? "-"}°C a ${item.faixa_temp_max ?? "-"}°C`);
  }
  if (item?.faixa_umid_min != null || item?.faixa_umid_max != null) {
    partes.push(`Umidade ${item.faixa_umid_min ?? "-"}% a ${item.faixa_umid_max ?? "-"}%`);
  }
  return partes.join(" | ");
};

export const FaixaPermitidaTermo = ({ formData, setFormData }) => {
  const campo = (key, label, placeholder) => (
    <div className="space-y-1">
      <Label className="text-xs whitespace-nowrap">{label}</Label>
      <Input
        type="number"
        step="0.1"
        data-testid={`${key.replace(/_/g, "-")}`}
        value={formData[key] ?? ""}
        onChange={(e) => setFormData({ ...formData, [key]: e.target.value })}
        placeholder={placeholder}
        className="bg-white"
      />
    </div>
  );
  return (
    <div className="space-y-3 p-4 bg-orange-50 rounded-lg border border-orange-200" data-testid="faixa-permitida-section">
      <h4 className="font-medium text-orange-900 flex items-center gap-2">
        <Thermometer className="w-4 h-4" />
        Faixa permitida (termohigrômetro)
      </h4>
      <p className="text-sm text-orange-700">
        Leituras fora desta faixa marcam a verificação automaticamente como não conforme.
      </p>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {campo("faixa_temp_min", "Temp. mín (°C)", "15.0")}
        {campo("faixa_temp_max", "Temp. máx (°C)", "30.0")}
        {campo("faixa_umid_min", "Umidade mín (%)", "40.0")}
        {campo("faixa_umid_max", "Umidade máx (%)", "70.0")}
      </div>
    </div>
  );
};
